import {
  billingCycleDependBasePlanTypeList,
  dependMeetingPlanTypeList,
  licenseDependBasePlanTypeList,
  planTypes,
} from '@/common/constants';
import { planUnitMap } from '@/common/product-unit';
import { defaultMapper } from "@/common/service/default-mapper"

const LargeMeetingKey = [
    'large500',
    'large1000',
]

export default (planMapJSON) => {
    return LargeMeetingKey.reduce((pre, key) => {
        return [
            ...defaultMapper(planMapJSON[key], planTypes.LARGE_MEETING).map(item => ({
                ...item,
                capacity: planMapJSON[key].participants,
                participants: planMapJSON[key].participants,
                typeNameKey: 'billing.large_meeting.title',
                planNameKey: 'billing.large_meeting.title',
                dependBasePlanTypeList: dependMeetingPlanTypeList,
                billingCycleDependBasePlanTypeList,
                licenseDependBasePlanTypeList,
                unit: planUnitMap.license,
            })),
            ...pre,
        ]
    }, []);
}
